import React, { useEffect, useState } from "react"
import SiteLayout from "@/Layouts/SiteLayout"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { TermsBanner as Banner } from "@/Components/Terms/TermsBanner"
import { Seo } from "@/Components/Seo"
import { HeroPreload } from "@/Components/Common/HeroPreload"

import SellAGunBanner from "@/Components/Marketing/SellAGunBanner"
import { AuctionEndingSoon, ItemDescription } from "@/Components/GetItem"
import { MobileGallery } from "@/Components/GetItem/MobileGallery"
import { PhotoGrid } from "@/Components/GetItem/PhotoGrid"
import { BreadCrumbs } from "@/Components/GetItem/BreadCrumbs"
import { LoadingItems } from "@/Components/GetItem/LoadingItems"
import { useEchoPublic } from "@laravel/echo-react"
import WantToSellAGunCTA from "@/Components/Marketing/WantToSellAGunCTA"

export default function ProductDescription({ title, description, item, items, schemas, breadcrumbs, brandFacets = null, soldListing = null, sellCta = null, heroPreload = null }) {
    const [data, setData] = useState(item)
    const images = data.gun?.photo_array

    useEchoPublic(`App.Models.Auction.${data.id}`, "AuctionUpdated", (e) =>
        setData(e.auction)
    )

    const [showTableModalMobile, setShowTableModalMobile] = useState(false)
    const [showMainModal, setShowMainModal] = useState(false)
    const [showAdditionalSlider, setShowAdditionalSlider] = useState(false)

    useEffect(() => {
        if (showMainModal || showAdditionalSlider || showTableModalMobile) {
            document.body.style.overflow = "hidden"
        } else {
            document.body.style.overflow = "unset"
        }

        return () => {
            document.body.style.overflow = "unset"
        }
    }, [showMainModal, showAdditionalSlider, showTableModalMobile])

    return (
        <>
            <Seo
                title={title}
                description={description}
                image={images[0]}
                type="product"
                schemas={schemas}
            />
            {heroPreload && <HeroPreload {...heroPreload} />}
            <SiteLayout>
                <SellAGunBanner />

                <div className="container px-5 mx-auto lg:my-8 2xl:px-0">
                    <BreadCrumbs breadcrumbs={breadcrumbs} />

                    <h1 className="text-[25px] lg:text-[32px] leading-[38.4px] font-medium mb-2">
                        {"Used " + data.gun?.title_for_gunbroker}
                    </h1>
                    <h2 className="text-[15px] lg:text-xl font-light leading-[24.2px] mb-2 lg:mb-0">
                        {data.gun.subtitle_for_gunbroker}
                    </h2>
                    <MobileGallery item={data} />

                    <PhotoGrid item={data} />

                    <div className="pb-10">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-[50px] xl:gap-x-[80px]">
                            <ItemDescription
                                item={data}
                                soldListing={soldListing}
                                brandFacets={brandFacets}
                            />

                            <div>
                                <WantToSellAGunCTA copy={sellCta} />

                                <h3 className="text-[32px] lg:text-[32px] my-[48px] font-medium mb-4">
                                    {items?.[0]?.status === "SOLD"
                                        ? "Similar Items"
                                        : "Explore Other Auctions"}
                                </h3>
                                {items ? (
                                    <AuctionEndingSoon items={items} />
                                ) : (
                                    <div className="flex-none">
                                        <LoadingItems />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="hidden lg:block">
                        <Banner />
                    </div>
                </div>
            </SiteLayout>
        </>
    )
}
